import api from '@/apis'

export default {
  state: {
    visibility: false,
    task_id: null,
    user_id: null,
    group_id: null,
    transcript_id: null,
    submit_btn_disable: false,
    type: ''
  },
  mutations: {
    INIT_DELETE_DIALOG(state, payload) {
      state.visibility = true
      state.task_id = payload.task_id ? payload.task_id : null
      state.user_id = payload.user_id ? payload.user_id : null
      state.group_id = payload.group_id ? payload.group_id : null
      state.transcript_id = payload.transcript_id ? payload.transcript_id : null
      state.type = payload.type
    },
    RESET_DELETE_DIALOG(state) {
      state.visibility = false
      state.task_id = null
      state.user_id = null
      state.group_id = null
      state.type = ''
    },
    SET_DELETE_DIALOG_SUBMIT_BTN_DISABLE(state, payload) {
      state.submit_btn_disable = payload
    }
  },
  actions: {
    async deleteUser({ state, commit, dispatch }) {
      try {
        commit('SET_SNACKBAR', { status: true, color: 'loading', text: 'Deleting...', loading: true })
        commit('SET_DELETE_DIALOG_SUBMIT_BTN_DISABLE', true)
        const data = {
          params: { user_id: state.user_id },
          headers: {
            access_token: process.env.VUE_APP_AUDIO_FILE_TO_TEXT_AUTH_TOKEN
          }
        }
        const response = await api.deleteUser(data)
        if (response.data.success) {
          commit('SET_SNACKBAR', { status: true, color: 'success', text: response.data.message, icon: 'check', timeout: '2000' })
          commit('RESET_DELETE_DIALOG')
          dispatch('fetchUserManagementList')
        } else throw Error(response.data.message)
      } catch (error) {
        commit('SET_SNACKBAR', { status: true, color: 'error', text: error.message, icon: 'close', timeout: '2000' })
      } finally {
        commit('SET_DELETE_DIALOG_SUBMIT_BTN_DISABLE', false)
      }
    },

    async deleteAudioFile({ state, commit, dispatch }) {
      try {
        commit('SET_SNACKBAR', { status: true, color: 'loading', text: 'Deleting...', loading: true })
        commit('SET_DELETE_DIALOG_SUBMIT_BTN_DISABLE', true)
        const data = {
          params: { task_id: state.task_id },
          headers: {
            access_token: process.env.VUE_APP_AUDIO_FILE_TO_TEXT_AUTH_TOKEN
          }
        }
        const response = await api.deleteAudioFile(data)
        if (response.data.success) {
          commit('SET_SNACKBAR', { status: true, color: 'success', text: response.data.message, icon: 'check', timeout: '2000' })
          commit('RESET_DELETE_DIALOG')
          dispatch('initAudioFileToTextTable', { search: '' })
        } else throw Error(response.data.message)
      } catch (error) {
        commit('SET_SNACKBAR', { status: true, color: 'error', text: error.message, icon: 'close', timeout: '2000' })
      } finally {
        commit('SET_DELETE_DIALOG_SUBMIT_BTN_DISABLE', false)
      }
    },
    async deleteExcelFile({ rootState, state, commit, dispatch }) {
      try {
        commit('SET_SNACKBAR', { status: true, color: 'loading', text: 'Deleting...', loading: true })
        commit('SET_DELETE_DIALOG_SUBMIT_BTN_DISABLE', true)
        const project_id = rootState.auth.project_id
        const data = {
          params: { project_id: project_id, task_id: state.task_id },
          headers: {
            access_token: process.env.VUE_APP_AUDIO_FILE_TO_TEXT_AUTH_TOKEN
          }
        }
        const response = await api.deleteExcelFile(data)
        if (response.data.success) {
          commit('SET_SNACKBAR', { status: true, color: 'success', text: response.data.message, icon: 'check', timeout: '2000' })
          commit('RESET_DELETE_DIALOG')
          dispatch('initFileToTextTable', { search: '' })
        } else throw Error(response.data.message)
      } catch (error) {
        commit('SET_SNACKBAR', { status: true, color: 'error', text: error.message, icon: 'close', timeout: '2000' })
      } finally {
        commit('SET_DELETE_DIALOG_SUBMIT_BTN_DISABLE', false)
      }
    },
    async deleteGroup({ state, commit, dispatch }) {
      try {
        commit('SET_SNACKBAR', { status: true, color: 'loading', text: 'Deleting...', loading: true })
        commit('SET_DELETE_DIALOG_SUBMIT_BTN_DISABLE', true)
        const data = {
          params: { group_id: state.group_id },
          headers: {
            access_token: process.env.VUE_APP_AUDIO_FILE_TO_TEXT_AUTH_TOKEN
          }
        }
        const response = await api.deleteGroup(data)
        if (response.data.success) {
          commit('SET_SNACKBAR', { status: true, color: 'success', text: response.data.message, icon: 'check', timeout: '2000' })
          commit('RESET_DELETE_DIALOG')
          dispatch('fetchGroupList')
        } else throw Error(response.data.message)
      } catch (error) {
        commit('SET_SNACKBAR', { status: true, color: 'error', text: error.message, icon: 'close', timeout: '2000' })
      } finally {
        commit('SET_DELETE_DIALOG_SUBMIT_BTN_DISABLE', false)
      }
    }
  }
}
